import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState, type ReactNode } from "react";

let appQueryClient: QueryClient | null = null;

export function createAppQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        gcTime: 5 * 60 * 1000,
        refetchOnWindowFocus: true,
        retry: 1,
        staleTime: 15 * 1000,
      },
      mutations: { retry: false },
    },
  });
}

export function clearAppQueryCache() {
  appQueryClient?.clear();
}

export function AppQueryProvider({ children }: { children: ReactNode }) {
  const [client] = useState(() => {
    const next = createAppQueryClient();
    appQueryClient = next;
    return next;
  });
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
